module.exports = __webpack_public_path__ + "static/media/loader1.25ef2804.gif";